import React, { createContext, useContext } from 'react';
import ChatTopicModal from './ChatTopicModal';
import '../../../../css/common/chat/ChatTopics.css';

const ChatTopicsContext = createContext<any>(null);
export const useChatTopicsContext = () => useContext(ChatTopicsContext);
export function ChatTopicsProvider({ value, children }: { value: any; children: React.ReactNode }) {
  return <ChatTopicsContext.Provider value={value}>{children}<ChatTopicModal topics={value} /></ChatTopicsContext.Provider>;
}
